<div class="right-sidebar-container" 
     [class.collapsed]="(layoutService.isRightSidebarCollapsed$ | async)"
     [class.expanded]="!(layoutService.isRightSidebarCollapsed$ | async)">
  <button class="right-sidebar-toggle" 
          [class.collapsed]="(layoutService.isRightSidebarCollapsed$ | async)"
          (click)="layoutService.toggleRightSidebar()">
    <div  class="sidebar_collapse_btn_banner">
      <span  class="hamburger">
        <span ></span>
        <span ></span>
        <span ></span>
      </span>
    </div>
  </button>
  <div class="right-sidebar-content">
    <!-- Show project-status and notifications only when NOT on task/issue details pages -->
    <!-- Show notifications only on dashboard page -->
    <ng-container *ngIf="!isOnTaskDetailsPage && !isOnIssueDetailsPage && !isOnRevisionDetailsPage && !isOnRequestDetailsPage">
      <ng-container [ngSwitch]="layoutService.rightSidebarContent$ | async">
        <app-project-status #projectStatusComponent *ngSwitchCase="'project-status'"></app-project-status>
        <ng-container *ngSwitchCase="'notifications'">
          <app-notifications *ngIf="isOnDashboardPage"></app-notifications>
        </ng-container>
      </ng-container>
    </ng-container>
    
    <!-- Show task-status only when on task details page -->
    <ng-container *ngIf="isOnTaskDetailsPage">
      <app-task-status [taskId]="currentTaskId" [refreshTrigger]="statusSidebarRefreshService.refreshTrigger()"></app-task-status>
    </ng-container>
    
    <!-- Show issue-status only when on issue details page -->
    <ng-container *ngIf="isOnIssueDetailsPage">
      <app-issue-status [issueId]="currentIssueId"></app-issue-status>
    </ng-container>

    <!-- Show revision-status only when on revision details page -->
    <ng-container *ngIf="isOnRevisionDetailsPage">
      <app-revision-status [revisionId]="currentRevisionId"></app-revision-status>
    </ng-container>

    <!-- Show request-status only when on request details page -->
    <ng-container *ngIf="isOnRequestDetailsPage">
      <app-request-status [requestId]="currentRequestId"></app-request-status>
    </ng-container>
  </div>
</div>
